// Copyright (c) 2016 Deere & Company

import * as sharedClaimTypesActionCreator from '../../../shared/action-creators/get-claim-types';
import actions from '../../actions-list';

export const readClaimTypes = () => sharedClaimTypesActionCreator.readClaimTypes(actions.UPDATE_PRODUCT_DETAILS_CLAIM_TYPES);



// WEBPACK FOOTER //
// ./src/product/details/action-creators/get-claim-types.js